import { Role } from 'auth';

export default class OrgRole {
  organizationId: number = null;
  userId: number = null;
  personId: number = null;
  type: Role = null;
  permissions: string[] = [];
}
